import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Image } from 'react-bootstrap';
import Badge from '../Badge';

function ContentLabel({
  label,
  sublabel,
  badge,
  disabled,
  image,
  className,
  description,
  size,
  time,
  children,
}) {
  return (
    <div className={classNames('content-container', className)}>
      <div className={classNames('content-label', { 'content-label-lg': size === 'lg' })}>
        {image && <Image src={image} alt="label" className="label-image" />}
        <div className="label-container">
          <div className={classNames('label', { disabled })}>
            <span className="label-text">{label}</span>
            {sublabel && <span className="label-sublabel">({sublabel})</span>}
            {badge && <Badge variant="light-info" size="sm" className="label-badge">{badge}</Badge>}
          </div>
          <div className="label-description">
            {time && (
              <span className="label-time">
                {time}
                {description && <span className="label-time-separator"> • </span>}
              </span>
            )}
            {description}
          </div>
        </div>
      </div>
      {children && <div className="content-children">{children}</div>}
    </div>
  );
}

ContentLabel.propTypes = {
  label: PropTypes.string.isRequired,
  sublabel: PropTypes.string,
  badge: PropTypes.string,
  image: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.string,
  size: PropTypes.string,
  time: PropTypes.string,
  children: PropTypes.node,
};

ContentLabel.defaultProps = {
  sublabel: '',
  badge: '',
  image: '',
  disabled: false,
  className: '',
  description: '',
  size: '',
  time: '',
  children: null,
};

function ContentCard({
  title,
  subtitle,
  image,
  description,
  className,
  size,
  onHide,
}) {
  return (
    <Card className={classNames('content-card', className)}>
      <ContentLabel
        label={title}
        sublabel={subtitle}
        image={image}
        description={description}
        size={size}
      />
      <div className="close-icon-container" onClick={onHide} role="button" tabIndex={0} onKeyPress={onHide}>
        <i className="ri-close-line close-icon" />
      </div>
    </Card>
  );
}

ContentCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  onHide: PropTypes.func.isRequired,
};

ContentCard.defaultProps = {
  subtitle: '',
  image: '',
  description: '',
  className: '',
  size: '',
};

export { ContentLabel, ContentCard };
